import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Form, Button, Row, Col, Table } from "react-bootstrap";
import DatePicker from "../../components/AppDatePicker";
import companyLogo from "../../assets/images/logo.png";
import SunEditor from "suneditor-react";
import uploadRetreat from "../../assets/images/uploadRetreat.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import AuthApi from "../../api/authApi";
import RetreatApi from "../../api/retreatApi";
import AdminApi from "../../api/admin";
import PriestApi from "../../api/priestApi";
import { useTranslation } from "react-i18next";
import AlertDelete from "../../components/AlertDelete";
import DescriptionSampleTip from "../../components/DescriptionSampleTip";
import moment from "moment-timezone";
import { useNavigate, Link } from "react-router-dom";
import DeleteModel from "../../components/DeleteModel";
import ReCAPTCHA from "react-google-recaptcha";
import TimePicker from "../../components/TimePicker";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import ViewMailMsg from "../../components/ViewMailMsg";
import PhoneInput from "../../components/PhoneInput";
import CopyableInput from "../../components/CopyableInput";
import RegistrationPasswordAuth from "../../components/RegistrationPasswordAuth";
import { formatParishOptionLabel } from "../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../utils/coupleLabels";
import {
  getRetreatImagePreviewSrc,
  processRetreatImage,
  RETREAT_IMAGE_ACCEPT,
} from "../../utils/processRetreatImage";
import UpdatePriestPopUp from "../Priest/UpdatePriestPopUp";
import { Cookies } from "react-cookie";
import SampleContentApi from "../../api/SampleContentApi";
import RetreatImageUploadInfo from "../../components/RetreatImageUploadInfo";

const site_key = process.env.REACT_APP_CAPTCHA_SITE_KEY;

const CreateOuterRetreat = () => {
  let authApi = new AuthApi();
  let adminApi = new AdminApi();
  let retreatApi = new RetreatApi();
  let priestApi = new PriestApi();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [missionStatement, setMissionStatement] = useState("");
  const [description, setDescription] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [isTempUpload1, setIsTempUpload1] = useState(false);
  const [descriptionSample, setDescriptionSample] = useState(false);
  const [mailSample, setMailSample] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [Pass, setPass] = useState(false);
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [parishList, setParishList] = useState([]);
  const [allCoupleMails, setAllCoupleMails] = useState([]);
  const [fullCouples, setFullCouples] = useState([]);
  const [fullPriests, setFullPriests] = useState([]);
  const [accessGreenTick, setAccessGreenTick] = useState(false);
  const [coupleSelectForAccess, setCoupleSelectForAccess] = useState([]);
  const [mailMsgView, setMailMsgView] = useState(false);
  const [check, setCheck] = useState("");
  const [showPriestModal, setShowPriestModal] = useState(false);
  const [priestData, setPriestData] = useState({
    id: "",
    parishId: null,
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    imageUrl: "",
    address: "",
  });
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [alreadyPk, setAlreadyPk] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [oldPriestValues, setOldPriestValues] = useState([]);
  const [isTempPriestUpload, setIsTempPriestUpload] = useState(false);
  const [selectedPriestOption, setSelectedPriestOption] = useState(null);
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [dynamicEmailMsg, setDynamicEmailMsg] = useState("");

  const cookies = new Cookies();
  const userData = cookies.get("LoveStrongUser") || null;
  const isAdmin = userData && userData.userRole === "ADMIN";
  const [isPasswordVerified, setIsPasswordVerified] = useState(
    isAdmin || !!sessionStorage.getItem("retreat-registration-password"),
  );

  const [data, setData] = useState({
    parishId: "",
    language: "",
    location: "",
    schedule: [],
    image1: "",
    heading: "",
    mission_statement: `"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."`,
    description: "",
    mail_msg: "",
    retreat_team: [
      {
        role: "lead_couple",
        hisFirstName: "",
        hisLastName: "",
        hisEmail: "",
        herFirstName: "",
        herLastName: "",
        herEmail: "",
      },
      {
        role: "co_lead_couple",
        hisFirstName: "",
        hisLastName: "",
        hisEmail: "",
        herFirstName: "",
        herLastName: "",
        herEmail: "",
      },
      {
        role: "mentor_couple",
        hisFirstName: "",
        hisLastName: "",
        hisEmail: "",
        herFirstName: "",
        herLastName: "",
        herEmail: "",
      },
      {
        role: "spiritual_director",
        firstName: "",
        lastName: "",
        email: "",
      },
    ],
    contact_name: "",
    contact_email: "",
    contact_mobile: "",
    paymentLink: "",
  });

  const recaptchaRef = useRef();

  const formattedDate = (date) => {
    return moment(date).tz("America/New_York").format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (isPasswordVerified) {
      getParishList();
      getAllCouples();
      getAllPriests();
    }
  }, [isPasswordVerified]);

  const loadDescriptionAndEmailSamples = (lang) => {
    const selectedLang = lang || "english";
    const sampleContentApi = new SampleContentApi();
    sampleContentApi
      .getSampleContent("Retreat Description", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicDescription(res.data.content);
        else setDynamicDescription("");
      });
    sampleContentApi
      .getSampleContent("Retreat Email Message", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicEmailMsg(res.data.content);
        else setDynamicEmailMsg("");
      });
  };

  useEffect(() => {
    loadDescriptionAndEmailSamples(data?.language);
    if (data?.language) {
      const sampleContentApi = new SampleContentApi();
      sampleContentApi
        .getSampleContent("Mission Statement", data.language)
        .then((res) => {
          if (res.success && res.data) setMissionStatement(res.data.content);
        });
    }
  }, [data?.language]);

  const getMissionStatement = async () => {
    await authApi
      .getMissionStatement()
      .then((response) => {
        if (response && response.data && response.data.mission_statement) {
          setMissionStatement(response.data.mission_statement);
        } else {
          setMissionStatement(
            `<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`,
          );
        }
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const handleChanges = (e) => {
    let { name, value } = e.target;
    let d = { ...data };
    if (e.target.name === "language") {
      const selectedLang = e.target.value;
      let sampleContentApi = new SampleContentApi();
      sampleContentApi.getSampleContent("Mission Statement", selectedLang).then(res => {
        if (res.success && res.data) {
          setMissionStatement(res.data.content);
          d.mission_statement = res.data.content.replace(/<[^>]*>/g, '');
        } else {
          if (selectedLang === "spanish") {
            d.mission_statement = `"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."`;
            setMissionStatement(`<p><em>"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."</em></p>`);
          } else {
            d.mission_statement = `"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."`;
            setMissionStatement(`<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`);
          }
        }
        setData({ ...d });
      });

      loadDescriptionAndEmailSamples(selectedLang);

      i18n.changeLanguage(selectedLang);
    }
    if (name === "image1") {
      const file = e.target.files[0];
      if (file) {
        processRetreatImage(file)
          .then((processedFile) => {
            d[name] = processedFile;
            toast.success("The retreat image has been successfully added.");
            setData({ ...d });
          })
          .catch((error) => {
            toast.error(error.message);
            e.target.value = "";
          });
      }
      return;
    } else {
      d[name] = value;
    }

    setData(d);

    if (name === "contact_email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({
          ...prev,
          [name]: t("invalid_email_format"),
        }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const upload = () => {
    document.getElementById("retreatImageUpload").click();
  };

  const remove = () => {
    let d = { ...data };
    d.image1 = "";
    setData(d);
    setIsTempUpload1(false);
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const hasErrors = Object.values(emailErrors).some((error) => error !== "");
    if (hasErrors) {
      toast.error(t("vaild_email_address"));
      return;
    }

    if (form.checkValidity()) {
      if (data.schedule.length) {
        if (check === "") {
          const recaptchaValue = recaptchaRef.current.getValue();
          // Verify reCAPTCHA here
          // if (recaptchaValue) {
          setIsTempUpload1(false);
          let data1 = new FormData();
          data1.append("file1", data.image1);
          let stateRef = { ...data };
          stateRef.mission_statement = missionStatement;
          stateRef.description = description;
          stateRef.mail_msg = emailMsg;
          delete stateRef.image1;
          stateRef.token = recaptchaValue;
          if (stateRef.coupleData) {
            stateRef.subAdmins = stateRef.coupleData;
            delete stateRef.coupleData;
          }
          data1.append("fromData", JSON.stringify(stateRef));
          // Proceed with form submission
          authApi
            .createTempRetreat(data1)
            .then((res) => {
              if (res.success) {
                if (res.msg == "Retreat added successfully.") {
                  toast.success(t("successfully_retreat_added"));
                }
                navigate("/thankyou", {
                  state: {
                    condition: "New Register Retreat",
                    language: data && data.language,
                  },
                });
              } else {
                if (res.msg == "Atleast one Date is required.") {
                  toast.error(t("atleast_one_date_required"));
                } else if (res.msg == "Retreat already exists.")
                  toast.error(t("retreat_already_exists"));
                else {
                  toast.error(res.msg);
                }
              }
            })
            .catch((error) => {
              toast.error(error);
            });
          // } else {
          //   toast.error("Please Submit Captcha");
          // }
        }
      } else {
        toast.error("Atleast one time schedule is required!");
      }
    }
    setValidated(true);
  };

  const handleCloseAlert = () => {
    setDescriptionSample(false);
    setMailSample(false);
  };

  const handleTimeChange = (name, value, index) => {
    const newData = { ...data };

    // Ensure the schedule array has an entry at the specified index
    if (!newData.schedule[index]) {
      newData.schedule[index] = {};
    }

    if (name.includes("date")) {
      const isValid = value && moment(value).isValid();
      if (isValid) {
        // Adjust the date for the specified timezone
        const adjustedDate = moment(value)
          .tz("America/New_York", true)
          .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");

        // Set the date property for the schedule entry at the given index
        newData.schedule[index].date = adjustedDate;

        // Auto-fill other dates
        if (index === 0) {
          // Friday selected, set Saturday and Sunday
          const satDate = moment(value).add(1, "days");
          const sunDate = moment(value).add(2, "days");
          if (!newData.schedule[1]) newData.schedule[1] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 1) {
          // Saturday selected, set Friday and Sunday
          const friDate = moment(value).subtract(1, "days");
          const sunDate = moment(value).add(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 2) {
          // Sunday selected, set Friday and Saturday
          const friDate = moment(value).subtract(2, "days");
          const satDate = moment(value).subtract(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[1]) newData.schedule[1] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        }
      } else {
        newData.schedule[index].date = "";
        if (index === 0) {
          if (newData.schedule[1]) newData.schedule[1].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 1) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 2) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[1]) newData.schedule[1].date = "";
        }
      }

      // Update day name based on the adjusted date and language
      newData.schedule.forEach((item) => {
        if (item.date && moment(item.date).isValid()) {
          item.dayName = getDayName(item.date, newData.language);
        } else {
          item.dayName = "";
        }
      });
    } else if (name.includes("from")) {
      // Check if "From" and "To" times are the same
      if (newData.schedule[index].to && newData.schedule[index].to === value) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].from = value;
      }
    } else if (name.includes("to")) {
      // Check if "To" and "From" times are the same
      if (
        newData.schedule[index].from &&
        newData.schedule[index].from === value
      ) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].to = value;
      }
    }

    setData(newData);
  };

  const handleRetreatTeam = (e, couple) => {
    const { name, value } = e.target;
    setData((prevData) => {
      // Find the index of the couple role in the retreat_team array
      const updatedTeam = prevData.retreat_team.map((member) =>
        member.role === couple ? { ...member, [name]: value } : member,
      );
      return {
        ...prevData,
        retreat_team: updatedTeam,
      };
    });

    if (name === "hisEmail" || name === "herEmail" || name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const errorKey = `${couple}_${name}`;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({
          ...prev,
          [errorKey]: t("invalid_email_format"),
        }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [errorKey]: "" }));
      }
    }
  };

  function getDayName(dateString, language) {
    const dateInUSTimezone = moment(dateString).tz("America/New_York");
    let days = [];
    if (language === "spanish") {
      days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
    } else {
      days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    }
    return days[dateInUSTimezone.day()];
  }

  const deleteSchedule = () => {
    let d = { ...data };
    if (d.schedule.length > 0) {
      d.schedule.splice(editIndex, 1);
    }
    setShow(false);
  };

  const handleClose = () => {
    setEditIndex(null);
    setShow(false);
  };

  const getParishList = async () => {
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setParishList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) {
      namePart += lastName;
    }

    if (firstName) {
      namePart += (lastName ? ", " : "") + firstName;
    }

    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          let allMailcoupleList = [];
          res.data && setFullCouples(res.data);
          res.data &&
            res.data.forEach((item) => {
              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });
          await adminApi.outerUsers().then((res) => {
            if (res.success) {
              res.data &&
                res.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getAllPriests = async () => {
    await priestApi
      .getAllPriests()
      .then((res) => {
        if (res.success) {
          setFullPriests(res.data);
        }
      })
      .catch((err) => {
        toast.error(err.toString());
      });
  };

  const handleSelectExistingCouple = (selectedOption, role) => {
    if (!selectedOption) {
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === role
            ? {
                ...member,
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
      return;
    }
    const coupleData = fullCouples.find((c) => c.id === selectedOption.value);
    if (coupleData) {
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === role
            ? {
                ...member,
                hisFirstName: coupleData.hisFirstName || "",
                hisLastName: coupleData.hisLastName || "",
                hisEmail: coupleData.hisEmail || "",
                herFirstName: coupleData.herFirstName || "",
                herLastName: coupleData.herLastName || "",
                herEmail: coupleData.herEmail || "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
    }
  };

  const handleSelectExistingPriest = (
    selectedOption,
    directPriestData = null,
  ) => {
    if (!selectedOption) {
      setSelectedPriestOption(null);
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === "spiritual_director"
            ? {
                ...member,
                firstName: "",
                lastName: "",
                email: "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
      return;
    }

    setSelectedPriestOption(selectedOption);

    const priestData =
      directPriestData ||
      fullPriests.find((p) => p.id === selectedOption.value);
    if (priestData) {
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === "spiritual_director"
            ? {
                ...member,
                firstName: priestData.firstName || "",
                lastName: priestData.lastName || priestData.name || "",
                email: priestData.email || "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
    }
  };

  const handleAddPriestClick = async () => {
    setEdiUserIdClicked("");
    setPriestData({
      id: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    await priestApi
      .checkPKPriest()
      .then((res) => {
        if (res.success) {
          const nextPk = res.data || "P101";
          setAlreadyPk(nextPk);
          setPriestData((prev) => ({ ...prev, primaryKey: nextPk }));
          setShowPriestModal(true);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const handlePriestSuccess = (newPriest) => {
    if (newPriest) {
      setFullPriests((prev) => [...prev, newPriest]);
      const label = `${newPriest.title ? newPriest.title + " " : ""}${newPriest.firstName} ${newPriest.lastName || newPriest.name}`;
      handleSelectExistingPriest(
        {
          label: label,
          value: newPriest.id,
        },
        newPriest,
      );
    }
  };

  const coupleOptions = fullCouples.map((item) => ({
    label: formatCoupleOptionLabel(item),
    value: item.id,
  }));

  const priestOptions = fullPriests.map((item) => ({
    label: `${item.title ? item.title + " " : ""}${item.firstName} ${
      item.lastName || item.name
    }`,
    value: item.id,
  }));

  const handleSelectOption = (val) => {
    setCoupleSelectForAccess(val);
  };

  const handleAccessSubmit = async () => {
    if (coupleSelectForAccess && coupleSelectForAccess.length) {
      const submitData = coupleSelectForAccess.map((option) => ({
        label: option.label,
        value: option.value,
      }));
      setAccessGreenTick(true);
      setData((prev) => {
        const existing = prev.coupleData || [];
        const merged = [
          ...existing,
          ...submitData.filter(
            (newItem) => !existing.some((ex) => ex.value === newItem.value),
          ),
        ];
        return {
          ...prev,
          coupleData: merged,
        };
      });
      setCoupleSelectForAccess([]);
      setTimeout(() => {
        setAccessGreenTick(false);
      }, 2000);
    } else {
      toast.error(t("select_create_sub_admin_alert"));
    }
  };

  const handlerAccessRmvShow = (item) => {
    setData((prev) => ({
      ...prev,
      coupleData: prev.coupleData.filter((c) => c.value !== item.value),
    }));
  };

  return (
    <RegistrationPasswordAuth onVerified={() => setIsPasswordVerified(true)}>
      <div className="container-scroller mainpannel">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="row w-100 mx-0">
              <div className="col-lg-10 mx-auto">
                <Link
                  to="/create-ticket"
                  state={{ pageName: "register-new-retreat" }}
                  // href="blank"
                  target="_blank"
                >
                  <div className="helpDiv">
                    <span className="helpMdi">{t("help")}</span>
                    <i
                      className="mdi mdi-help-circle"
                      style={{ fontSize: "22px" }}
                    ></i>
                  </div>
                </Link>
              </div>

              <div className="col-lg-10 mx-auto">
                <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                  <Link to="/dashboard">
                    {" "}
                    <div className="brand-logo">
                      <img
                        src={companyLogo}
                        alt="logo"
                        className="logo center"
                      />
                    </div>
                  </Link>

                  <div className="text-center mb-4">
                    <h3 className="registerNewRetreat">
                      {t("register_new_retreat")}
                    </h3>
                  </div>
                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    validated={validated}
                    className="forms-sample"
                  >
                    <Row>
                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("select_retreat_language")}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            size="sm"
                            type="text"
                            name="language"
                            id="language"
                            placeholder="Language"
                            value={data.language}
                            className="language-selection"
                            onChange={(e) => handleChanges(e)}
                          >
                            <option value="">{t("select")}</option>
                            <option value="english" className="dark-option">
                              English
                            </option>
                            <option value="spanish" className="dark-option">
                              Spanish
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {t("language_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("enter_Parish_name")}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            size="sm"
                            type="text"
                            name="parishId"
                            id="parishId"
                            placeholder="Parish"
                            value={data.parishId}
                            className="language-selection"
                            onChange={(e) => handleChanges(e)}
                          >
                            <option value="" className="dark-option">
                              {t("select_parish")}
                            </option>
                            {parishList
                              .filter(
                                (item) =>
                                  item.parishCategoryName?.toUpperCase() !==
                                  "OTHER",
                              )
                              .map((item, index) => {
                                return (
                                  <option
                                    key={item.id}
                                    className="dark-option"
                                    value={item.id}
                                  >
                                    {formatParishOptionLabel(item)}
                                  </option>
                                );
                              })}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {t("parish_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("enter_location")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            name="location"
                            id="location"
                            placeholder={t("location")}
                            value={data.location}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("location_required")}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="form-group">
                          <Form.Label>{t("retreat_theme")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="heading"
                            id="heading"
                            placeholder={t("retreat_theme")}
                            value={data.heading}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("retreat_theme_required")}
                          </Form.Control.Feedback>
                        </Form.Group>




                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("retreat_payment_link")} <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            name="paymentLink"
                            id="paymentLink"
                            placeholder={t("retreat_payment_link")}
                            value={data.paymentLink}
                            onChange={(e) => handleChanges(e)}
                            // readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("payment_link_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={6} xs={12}>
                        <Form.Group>
                          {data.image1 == "" || data.image1 == undefined ? (
                            <div className="edit-profile-img mb-2 text-center">
                              <img src={uploadRetreat} />
                            </div>
                          ) : (
                            <div className="edit-profile-img mb-2 text-center">
                              <img
                                src={getRetreatImagePreviewSrc(data?.image1)}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = corruptedImg;
                                }}
                              />
                            </div>
                          )}{" "}
                          <div className="img-assumption">
                            {t("retreat_img_size")}
                          </div>
                          <div className="text-center mt-3">
                            {data.image1 == "" || data.image1 == undefined ? (
                              <>
                                <input
                                  name="image1"
                                  className="pt-1"
                                  type="file"
                                  accept={RETREAT_IMAGE_ACCEPT}
                                  style={{ display: "none" }}
                                  id="retreatImageUpload"
                                  onChange={(e) => handleChanges(e)}
                                />
                                <span className="d-inline-flex align-items-center justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="mb-1 text-center"
                                    onClick={(e) => {
                                      upload();
                                    }}
                                  >
                                    {t("upload_retreat_image")}
                                  </Button>
                                  <RetreatImageUploadInfo />
                                </span>
                              </>
                            ) : (
                              <Button
                                variant="danger"
                                className="mb-1 mt-2 "
                                onClick={(e) => {
                                  remove();
                                }}
                              >
                                {t("remove")}
                              </Button>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      <hr />

                      <Col lg={12} md={12} xs={12} className="mt-3">
                        <Row>
                          <Col lg={2} md={2} xs={2} className="mt-4">
                            <h4>{t("friday")}</h4>
                          </Col>

                          <Col lg={4} md={4} xs={12}>
                            {" "}
                            <div>
                              <div>
                                {" "}
                                <Form.Label>
                                  {t("date")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <DatePicker
                                required={
                                  data.schedule && data.schedule.length
                                    ? false
                                    : true
                                }
                                autoComplete="off"
                                id="dateId"
                                dateFormat="MM-dd-yyyy"
                                placeholderText="mm-dd-yyyy"
                                className="form-select"
                                selected={
                                  (() => {
                                    const dStr = data?.schedule?.[0]?.date;
                                    if (!dStr || dStr === "Invalid date") return null;
                                    const m = moment(formattedDate(dStr));
                                    return m.isValid() ? m.toDate() : null;
                                  })()
                                }
                                name="date0"
                                onChange={(date) =>
                                  handleTimeChange("date0", date, 0)
                                }
                                filterDate={(date) => date.getDay() === 5} // 5 represents Friday
                                renderCustomHeader={({
                                  date,
                                  changeYear,
                                  changeMonth,
                                  decreaseMonth,
                                  increaseMonth,
                                  prevMonthButtonDisabled,
                                  nextMonthButtonDisabled,
                                }) => {
                                  const years = Array.from(
                                    { length: 100 },
                                    (_, i) => new Date().getFullYear() - i,
                                  );
                                  const months = [
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June",
                                    "July",
                                    "August",
                                    "September",
                                    "October",
                                    "November",
                                    "December",
                                  ];

                                  return (
                                    <div
                                      style={{
                                        textAlign: "center",
                                        paddingBottom: "8px",
                                      }}
                                    >
                                      {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          display: "flex",
                                          gap: "10px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* Month Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={months[date.getMonth()]}
                                          onChange={({ target: { value } }) =>
                                            changeMonth(months.indexOf(value))
                                          }
                                        >
                                          {months.map((month) => (
                                            <option key={month} value={month}>
                                              {month}
                                            </option>
                                          ))}
                                        </select>

                                        {/* Year Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={date.getFullYear()}
                                          onChange={({ target: { value } }) =>
                                            changeYear(value)
                                          }
                                        >
                                          {years.map((year) => (
                                            <option key={year} value={year}>
                                              {year}
                                            </option>
                                          ))}
                                        </select>
                                      </div>

                                      {/* ✅ Optional month navigation below */}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <button
                                          onClick={decreaseMonth}
                                          disabled={prevMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {"<"}
                                        </button>

                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {months[date.getMonth()]}{" "}
                                          {date.getFullYear()}
                                        </span>

                                        <button
                                          onClick={increaseMonth}
                                          disabled={nextMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {">"}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                {t("date_required")}
                              </Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label>{t("from")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("from0", time, 0)
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                value={
                                  data &&
                                  data.schedule[0] &&
                                  data.schedule[0].from
                                }
                                className="timePicker"
                              />
                              <Form.Control.Feedback type="invalid">
                                {t("time_from_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label>{t("to")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("to0", time, 0)
                                }
                                value={
                                  data &&
                                  data.schedule[0] &&
                                  data.schedule[0].to
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                className="timePicker indexVlues"
                              />{" "}
                              <Form.Control.Feedback type="invalid">
                                {t("time_to_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                        {" "}
                        {check && check === "0" ? (
                          <h5 className="text-danger mt-2">
                            {t("time_from_time_to_should_not_be_same")}
                          </h5>
                        ) : null}
                      </Col>
                      <Col lg={12} md={12} xs={12} className="mt-3">
                        <Row>
                          <Col lg={2} md={2} xs={2} className="mt-4">
                            <h4>{t("saturday")}</h4>
                          </Col>

                          <Col lg={4} md={4} xs={12}>
                            {" "}
                            <div>
                              <div>
                                {" "}
                                <Form.Label>
                                  {t("date")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <DatePicker
                                required={
                                  data.schedule && data.schedule.length
                                    ? false
                                    : true
                                }
                                autoComplete="off"
                                id="dateId"
                                dateFormat="MM-dd-yyyy"
                                placeholderText="mm-dd-yyyy"
                                className="form-select"
                                selected={
                                  (() => {
                                    const dStr = data?.schedule?.[1]?.date;
                                    if (!dStr || dStr === "Invalid date") return null;
                                    const m = moment(formattedDate(dStr));
                                    return m.isValid() ? m.toDate() : null;
                                  })()
                                }
                                name="date1"
                                onChange={(date) =>
                                  handleTimeChange("date1", date, 1)
                                }
                                filterDate={(date) => date.getDay() === 6}
                                renderCustomHeader={({
                                  date,
                                  changeYear,
                                  changeMonth,
                                  decreaseMonth,
                                  increaseMonth,
                                  prevMonthButtonDisabled,
                                  nextMonthButtonDisabled,
                                }) => {
                                  const years = Array.from(
                                    { length: 100 },
                                    (_, i) => new Date().getFullYear() - i,
                                  );
                                  const months = [
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June",
                                    "July",
                                    "August",
                                    "September",
                                    "October",
                                    "November",
                                    "December",
                                  ];

                                  return (
                                    <div
                                      style={{
                                        textAlign: "center",
                                        paddingBottom: "8px",
                                      }}
                                    >
                                      {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          display: "flex",
                                          gap: "10px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* Month Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={months[date.getMonth()]}
                                          onChange={({ target: { value } }) =>
                                            changeMonth(months.indexOf(value))
                                          }
                                        >
                                          {months.map((month) => (
                                            <option key={month} value={month}>
                                              {month}
                                            </option>
                                          ))}
                                        </select>

                                        {/* Year Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={date.getFullYear()}
                                          onChange={({ target: { value } }) =>
                                            changeYear(value)
                                          }
                                        >
                                          {years.map((year) => (
                                            <option key={year} value={year}>
                                              {year}
                                            </option>
                                          ))}
                                        </select>
                                      </div>

                                      {/* ✅ Optional month navigation below */}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <button
                                          onClick={decreaseMonth}
                                          disabled={prevMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {"<"}
                                        </button>

                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {months[date.getMonth()]}{" "}
                                          {date.getFullYear()}
                                        </span>

                                        <button
                                          onClick={increaseMonth}
                                          disabled={nextMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {">"}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }}
                              />
                              <Form.Control.Feedback type="invalid">
                                {t("date_required")}
                              </Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label> {t("from")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("from1", time, 1)
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                value={
                                  data &&
                                  data.schedule[1] &&
                                  data.schedule[1].from
                                }
                                className="timePicker"
                              />
                              <Form.Control.Feedback type="invalid">
                                {t("time_from_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label>{t("to")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("to1", time, 1)
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                value={
                                  data &&
                                  data.schedule[1] &&
                                  data.schedule[1].to
                                }
                                className="timePicker indexVlues"
                              />{" "}
                              <Form.Control.Feedback type="invalid">
                                {t("time_to_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                        {" "}
                        {check && check === "1" ? (
                          <h5 className="text-danger mt-2">
                            {t("time_from_time_to_should_not_be_same")}
                          </h5>
                        ) : null}
                      </Col>
                      <Col lg={12} md={12} xs={12} className="mt-3">
                        <Row>
                          <Col lg={2} md={2} xs={2} className="mt-4">
                            <h4>{t("sunday")}</h4>
                          </Col>
                          <Col lg={4} md={4} xs={12}>
                            {" "}
                            <div>
                              <div>
                                {" "}
                                <Form.Label>
                                  {t("date")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <DatePicker
                                required={
                                  data.schedule && data.schedule.length
                                    ? false
                                    : true
                                }
                                autoComplete="off"
                                id="dateId"
                                dateFormat="MM-dd-yyyy"
                                placeholderText="mm-dd-yyyy"
                                className="form-select"
                                selected={
                                  (() => {
                                    const dStr = data?.schedule?.[2]?.date;
                                    if (!dStr || dStr === "Invalid date") return null;
                                    const m = moment(formattedDate(dStr));
                                    return m.isValid() ? m.toDate() : null;
                                  })()
                                }
                                name="date2"
                                onChange={(date) =>
                                  handleTimeChange("date2", date, 2)
                                }
                                filterDate={(date) => date.getDay() === 0}
                                renderCustomHeader={({
                                  date,
                                  changeYear,
                                  changeMonth,
                                  decreaseMonth,
                                  increaseMonth,
                                  prevMonthButtonDisabled,
                                  nextMonthButtonDisabled,
                                }) => {
                                  const years = Array.from(
                                    { length: 100 },
                                    (_, i) => new Date().getFullYear() - i,
                                  );
                                  const months = [
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June",
                                    "July",
                                    "August",
                                    "September",
                                    "October",
                                    "November",
                                    "December",
                                  ];

                                  return (
                                    <div
                                      style={{
                                        textAlign: "center",
                                        paddingBottom: "8px",
                                      }}
                                    >
                                      {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          display: "flex",
                                          gap: "10px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* Month Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={months[date.getMonth()]}
                                          onChange={({ target: { value } }) =>
                                            changeMonth(months.indexOf(value))
                                          }
                                        >
                                          {months.map((month) => (
                                            <option key={month} value={month}>
                                              {month}
                                            </option>
                                          ))}
                                        </select>

                                        {/* Year Dropdown */}
                                        <select
                                          style={{
                                            fontSize: "16px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                          }}
                                          value={date.getFullYear()}
                                          onChange={({ target: { value } }) =>
                                            changeYear(value)
                                          }
                                        >
                                          {years.map((year) => (
                                            <option key={year} value={year}>
                                              {year}
                                            </option>
                                          ))}
                                        </select>
                                      </div>

                                      {/* ✅ Optional month navigation below */}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <button
                                          onClick={decreaseMonth}
                                          disabled={prevMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {"<"}
                                        </button>

                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {months[date.getMonth()]}{" "}
                                          {date.getFullYear()}
                                        </span>

                                        <button
                                          onClick={increaseMonth}
                                          disabled={nextMonthButtonDisabled}
                                          style={{
                                            fontSize: "18px",
                                            padding: "2px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {">"}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }}
                              />
                              <Form.Control.Feedback type="invalid">
                                {t("date_required")}
                              </Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label> {t("from")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("from2", time, 2)
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                value={
                                  data &&
                                  data.schedule[2] &&
                                  data.schedule[2].from
                                }
                                className="timePicker"
                              />
                              <Form.Control.Feedback type="invalid">
                                {t("time_from_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col lg={3} md={3} xs={5} className="timeData">
                            {" "}
                            <Form.Group className="form-group">
                              <Form.Label>{t("to")}</Form.Label>
                              <TimePicker
                                chekPicker={Pass}
                                useTwelveHourFormat={true}
                                showClockIcon={false}
                                showCloseIcon={true}
                                allowBackdrop={true}
                                onTimeChange={(time) =>
                                  handleTimeChange("to2", time, 2)
                                }
                                placeholder="00 : 00 am"
                                defaulValue="00 : 00"
                                value={
                                  data &&
                                  data.schedule[2] &&
                                  data.schedule[2].to
                                }
                                className="timePicker indexVlues"
                              />{" "}
                              <Form.Control.Feedback type="invalid">
                                {t("time_to_required")}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                        {" "}
                        {check && check === "2" ? (
                          <h5 className="text-danger mt-2">
                            {t("time_from_time_to_should_not_be_same")}
                          </h5>
                        ) : null}
                      </Col>

                      <Col lg={12} md={12} xs={12}>
                        {" "}
                        <Form.Group
                          className="form-group col-12"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>{t("description")}</Form.Label>
                          <h5
                            onClick={() => {
                              loadDescriptionAndEmailSamples(data?.language);
                              setDescriptionSample(true);
                            }}
                            className="btn sampleData"
                          >
                            {t("description_sample")}
                          </h5>
                          <SunEditor
                            id="description-editor"
                            type="text"
                            height="250px"
                            onChange={(e) => setDescription(e)}
                            setContents={description}
                            name="description"
                            inputProps={{}}
                            setOptions={{
                              buttonList: [
                                [
                                  "undo",
                                  "redo",
                                  "font",
                                  "fontSize",
                                  "formatBlock",
                                ],
                                ["bold", "underline", "italic", "removeFormat"],
                                [
                                  "fontColor",
                                  "hiliteColor",
                                  "outdent",
                                  "indent",
                                  "align",
                                  "horizontalRule",
                                  "list",
                                ],
                                ["fullScreen", "link", "save"],
                              ],
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("description_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={12} md={12} xs={12}>
                        <Form.Group
                          className="form-group col-12"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>{t("email_message")}</Form.Label>
                          <h5
                            onClick={() => setMailMsgView(true)}
                            className="btn sampleData"
                          >
                            {t("email_preview")}
                          </h5>
                          <h5
                            onClick={() => {
                              loadDescriptionAndEmailSamples(data?.language);
                              setMailSample(true);
                            }}
                            className="btn sampleData"
                          >
                            {t("sample_email_message")}
                          </h5>
                          <SunEditor
                            id="mail-msg-editor"
                            type="text"
                            height="250px"
                            onChange={(e) => setEmailMsg(e)}
                            setContents={emailMsg}
                            name="mail_msg"
                            inputProps={{}}
                            setOptions={{
                              buttonList: [
                                [
                                  "undo",
                                  "redo",
                                  "font",
                                  "fontSize",
                                  "formatBlock",
                                ],
                                ["bold", "underline", "italic", "removeFormat"],
                                [
                                  "fontColor",
                                  "hiliteColor",
                                  "outdent",
                                  "indent",
                                  "align",
                                  "horizontalRule",
                                  "list",
                                ],
                                ["fullScreen", "link", "save"],
                              ],
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Email message is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>


                      <Col lg={12} md={12} xs={12} className="mb-3">
                        <h3>{t("retreat_team")}</h3>
                      </Col>

                      <Col lg={4} md={4} xs={12} className="border-right">
                        <h4>{t("lead_couple")}</h4>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t("select_existing_couple")}
                            </Form.Label>
                            <Select
                              options={coupleOptions}
                              onChange={(opt) =>
                                handleSelectExistingCouple(opt, "lead_couple")
                              }
                              placeholder={t("select")}
                              isSearchable={true}
                              isClearable={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("his_first_name")} </Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisFirstName"
                              id="hisFirstName"
                              placeholder={t("his_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                              // readOnly={isEditAdmin}
                            />
                            <Form.Control.Feedback type="invalid">
                              His FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("his_last_name")} </Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisLastName"
                              id="hisLastName"
                              placeholder={t("his_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Last Name is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="hisEmail"
                              id="hisEmail"
                              placeholder={t("his_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.lead_couple_hisEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.lead_couple_hisEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("her_first_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herFirstName"
                              id="herFirstName"
                              placeholder={t("her_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("her_last_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herLastName"
                              id="herLastName"
                              placeholder={t("her_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her LastName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("her_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="herEmail"
                              id="herEmail"
                              placeholder={t("her_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.lead_couple_herEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.lead_couple_herEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                      </Col>

                      <Col lg={4} md={4} xs={12} className="border-right">
                        <h4>{t("co_lead_couple")}</h4>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t("select_existing_couple")}
                            </Form.Label>
                            <Select
                              options={coupleOptions}
                              onChange={(opt) =>
                                handleSelectExistingCouple(
                                  opt,
                                  "co_lead_couple",
                                )
                              }
                              placeholder={t("select")}
                              isSearchable={true}
                              isClearable={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_first_name")} </Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisFirstName"
                              id="hisFirstName"
                              placeholder={t("his_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                              // readOnly={isEditAdmin}
                            />
                            <Form.Control.Feedback type="invalid">
                              His FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_last_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisLastName"
                              id="hisLastName"
                              placeholder={t("his_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Last Name is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="hisEmail"
                              id="hisEmail"
                              placeholder={t("his_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.co_lead_couple_hisEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.co_lead_couple_hisEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("her_first_name")} </Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herFirstName"
                              id="herFirstName"
                              placeholder={t("her_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("her_last_name")} </Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herLastName"
                              id="herLastName"
                              placeholder={t("her_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her LastName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("her_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="herEmail"
                              id="herEmail"
                              placeholder={t("her_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "co_lead_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.co_lead_couple_herEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.co_lead_couple_herEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                      </Col>

                      <Col lg={4} md={4} xs={12}>
                        <h4>{t("mentor_couple")}</h4>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t("select_existing_couple")}
                            </Form.Label>
                            <Select
                              options={coupleOptions}
                              onChange={(opt) =>
                                handleSelectExistingCouple(opt, "mentor_couple")
                              }
                              placeholder={t("select")}
                              isSearchable={true}
                              isClearable={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_first_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisFirstName"
                              id="hisFirstName"
                              placeholder={t("his_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                              // readOnly={isEditAdmin}
                            />
                            <Form.Control.Feedback type="invalid">
                              His FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_last_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="hisLastName"
                              id="hisLastName"
                              placeholder={t("his_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Last Name is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("his_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="hisEmail"
                              id="hisEmail"
                              placeholder={t("his_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              His Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.mentor_couple_hisEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.mentor_couple_hisEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label> {t("her_first_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herFirstName"
                              id="herFirstName"
                              placeholder={t("her_first_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herFirstName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her FirstName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("her_last_name")}</Form.Label>
                            <Form.Control
                              // required
                              size="sm"
                              type="text"
                              name="herLastName"
                              id="herLastName"
                              placeholder={t("her_last_name")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herLastName || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her LastName is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col lg={12} md={12} xs={12}>
                          <Form.Group className="form-group">
                            <Form.Label>{t("her_email")}</Form.Label>
                            <CopyableInput
                              size="sm"
                              type="text"
                              name="herEmail"
                              id="herEmail"
                              placeholder={t("her_email")}
                              value={
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herEmail || ""
                              }
                              onChange={(e) =>
                                handleRetreatTeam(e, "mentor_couple")
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Her Email is required!
                            </Form.Control.Feedback>
                            {emailErrors.mentor_couple_herEmail && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {emailErrors.mentor_couple_herEmail}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                      </Col>
                    </Row>
                    <hr></hr>
                    <Col lg={4} md={4} xs={12} className="border-right">
                      <div className="d-flex align-items-center mb-2 gap-2">
                        <h4 className="mb-0">{t("spiritual_director")}</h4>
                        <Button
                          variant="primary"
                          className="btn-sm d-flex align-items-center gap-2"
                          onClick={handleAddPriestClick}
                          style={{ fontSize: "12px", border: "none" }}
                        >
                          <i className="mdi mdi-plus-circle"></i>
                          {t("create_new_priest")}
                        </Button>
                      </div>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("select_existing_priest")}</Form.Label>
                          <Select
                            options={priestOptions}
                            value={selectedPriestOption}
                            onChange={(opt) => handleSelectExistingPriest(opt)}
                            placeholder={t("select")}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label> {t("first_name")} </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="firstName"
                            id="firstName"
                            placeholder={t("first_name")}
                            value={
                              data.retreat_team.find(
                                (member) =>
                                  member.role === "spiritual_director",
                              )?.firstName || ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "spiritual_director")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            FirstName is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label> {t("last_name")} </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="lastName"
                            id="lastName"
                            placeholder={t("last_name")}
                            value={
                              data.retreat_team.find(
                                (member) =>
                                  member.role === "spiritual_director",
                              )?.lastName || ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "spiritual_director")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Last Name is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="email"
                            id="email"
                            placeholder={t("email")}
                            value={
                              data.retreat_team.find(
                                (member) =>
                                  member.role === "spiritual_director",
                              )?.email || ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "spiritual_director")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Email is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Col>
                    <hr></hr>
                    <Row>
                      <h3 className="mt-3 mb-3">{t("contact_information")}</h3>

                      <Col lg={4} md={4} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("enter_name")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            name="contact_name"
                            id="contact_name"
                            placeholder={t("contact_name")}
                            value={data.contact_name}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("contact_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("search_mail_placeholder")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <CopyableInput
                            required
                            size="sm"
                            type="contact_email"
                            name="contact_email"
                            id="contact_email"
                            placeholder={t("contact_email")}
                            value={data.contact_email}
                            onChange={(e) => handleChanges(e)}
                          />
                          {emailErrors.contact_email && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.contact_email}
                            </span>
                          )}
                          <Form.Control.Feedback type="invalid">
                            {t("contact_email_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("mobile_number")} (Ex- xxx-xxx-xxxx){" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <PhoneInput
                            name="contact_mobile"
                            value={data.contact_mobile}
                            onChange={handleChanges}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("contact_mobile_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <hr className="my-3" />

                      <Col>
                        <h3 className="mt-3 mb-3 administratorsHeader">
                          {t("retreat_administrators")}
                          <span
                            title={t("Retreat_administrators_tooltip")}
                            className="administratorsTitle"
                          >
                            <i className="mdi mdi-information-outline"></i>
                          </span>
                        </h3>
                        <div className="d-flex align-items-start gap-2">
                          <Select
                            className="flex-grow-1"
                            id="couple"
                            name="couple"
                            options={allCoupleMails}
                            value={coupleSelectForAccess}
                            onChange={handleSelectOption}
                            placeholder={t("select")}
                            isSearchable={true}
                            isMulti={true}
                            menuPlacement="top"
                          />
                          <div className="d-flex align-items-center">
                            {accessGreenTick ? (
                              <i
                                className="mdi mdi-check-circle text-success fs-3"
                                style={{ cursor: "default" }}
                              ></i>
                            ) : (
                              <i
                                onClick={handleAccessSubmit}
                                className="mdi mdi-plus-circle text-primary fs-3"
                                style={{ cursor: "pointer" }}
                              ></i>
                            )}
                          </div>
                        </div>

                        {data?.coupleData?.length > 0 ? (
                          <div className="selected-couples my-3">
                            {data.coupleData.map((item, index) => (
                              <div
                                key={index}
                                className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                              >
                                <span>{item.label}</span>
                                <i
                                  className="mdi mdi-delete-forever text-danger fs-4"
                                  onClick={() => handlerAccessRmvShow(item)}
                                  title={t("remove_couple")}
                                  style={{ cursor: "pointer" }}
                                ></i>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-muted">{t("no_couple_yet")}</p>
                        )}
                      </Col>
                      <hr className="my-3" />
                    </Row>
                    <ReCAPTCHA sitekey={site_key} ref={recaptchaRef} />
                    <Button className="mt-3" variant="primary" type="submit">
                      {t("submit")}
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {descriptionSample ? (
          <AlertDelete
            show={descriptionSample}
            alertHeader={t("description_sample")}
            alerMessage={
              <div>
                <DescriptionSampleTip />
                <div>
                  {dynamicDescription ? (
                    <div dangerouslySetInnerHTML={{ __html: dynamicDescription }} />
                  ) : data.language === "spanish" ? (
                    <div style={{ textAlign: "center" }}>
                      <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                        El costo es de $175 por pareja. Se requiere un depósito
                        de $75 al momento de enviar el formulario de
                        inscripción. El número de parejas que podemos acomodar
                        es limitado y la disponibilidad es por orden de llegada.
                        El costo de inscripción cubre la cena del viernes, tres
                        comidas el sábado y el desayuno y almuerzo del domingo.
                        También cubre todos los materiales del retiro. No se
                        proporciona cuidado de niños.
                      </p>

                      <p>
                        <strong>
                          <em>
                            Todas las parejas del retiro deben comprometerse a
                            asistir a todas las actividades del fin de semana de
                            3 días.
                          </em>
                        </strong>
                      </p>

                      <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                        Iglesia de San Pedro y San Pablo
                        <br />
                        386 N Castell Ave.,
                        <br />
                        New Braunfels, TX, 78130
                      </p>

                      <p>
                        Para preguntas, aquí está la información de contacto:
                      </p>

                      <p>
                        <a
                          href="mailto:solizspp.lovestrong@gmail.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#1155CC" }}
                        >
                          solizspp.lovestrong@gmail.com
                        </a>
                      </p>

                      <p style={{ color: "#222222" }}>
                        Phil (210-779-3096)
                        <br />
                        Jen (210-288-1908)
                      </p>

                      <p>¡Gracias!</p>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                        The cost is $175 per couple. A $75 deposit is due with
                        the registration form. We are limited as to the number
                        of couples we can accommodate, and availability is on a
                        first come, first-serve basis. The registration cost
                        covers dinner on Friday, three meals on Saturday, and
                        breakfast and lunch on Sunday. It will also cover all
                        retreat materials. Childcare is not provided.
                      </p>

                      <p>
                        <strong>
                          <em>
                            All Retreat Couples must commit to attending the
                            entire 3-day weekend’s activities.
                          </em>
                        </strong>
                      </p>

                      <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                        Sts. Peter and Paul Church
                        <br />
                        386 N Castell Ave.,
                        <br />
                        New Braunfels, TX, 78130
                      </p>

                      <p>For questions, here is the contact info:</p>

                      <p>
                        <a
                          href="mailto:solizspp.lovestrong@gmail.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#1155CC" }}
                        >
                          solizspp.lovestrong@gmail.com
                        </a>
                      </p>

                      <p style={{ color: "#222222" }}>
                        Phil (210-779-3096)
                        <br />
                        Jen (210-288-1908)
                      </p>

                      <p>Thank you!</p>
                    </div>
                  )}
                </div>
              </div>
            }
            handleClose={handleCloseAlert}
            buttonText={t("close")}
          />
        ) : null}

        {mailSample ? (
          <AlertDelete
            show={mailSample}
            alertHeader={t("sample_email_message")}
            alerMessage={
              <div>
                {dynamicEmailMsg ? (
                  <div dangerouslySetInnerHTML={{ __html: dynamicEmailMsg }} />
                ) : data.language === "spanish" ? (
                  <div style={{ textAlign: "center" }}>
                    <p>
                      Gracias por inscribirse en el retiro matrimonial
                      LOVESTRONG de San Pedro y San Pablo, programado del 18 al
                      20 de octubre de 2024. ¡Nos entusiasma que nos acompañen!
                    </p>
                    <p>Si tienes alguna pregunta, contáctanos aquí...</p>
                    <p>
                      <strong>Correo electrónico: </strong>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>
                    <p style={{ color: "rgb(34, 34, 34)" }}>
                      <strong>Jen Soliz</strong>
                      <br />
                      210-288-1908
                    </p>
                    <p style={{ color: "#222222" }}>
                      <strong>Phil Soliz</strong>
                      <br />
                      210-779-3096
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      Por favor, espere saber de nosotras pronto!
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      <strong>¡VIVE! ¡AMA! ¡FUERTE!</strong>
                    </p>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <p>
                      Thank you for registering for the Sts. Peter and Paul
                      LOVESTRONG Marriage retreat scheduled for October 18-20,
                      2024. We are excited that you will join us!
                    </p>
                    <p>
                      If you have any questions, please reach out to us here...
                    </p>
                    <p>
                      <strong>Email: </strong>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>
                    <p style={{ color: "rgb(34, 34, 34)" }}>
                      <strong>Jen Soliz</strong>
                      <br />
                      210-288-1908
                    </p>
                    <p style={{ color: "#222222" }}>
                      <strong>Phil Soliz</strong>
                      <br />
                      210-779-3096
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      Please expect to hear from us soon!
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      <strong>LIVE! LOVE! STRONG!</strong>
                    </p>
                  </div>
                )}
              </div>
            }
            handleClose={handleCloseAlert}
            buttonText={t("close")}
          />
        ) : null}

        {show ? (
          <DeleteModel
            show={show}
            handleClose={handleClose}
            DeleteData={deleteSchedule}
          ></DeleteModel>
        ) : null}

        {mailMsgView ? (
          <ViewMailMsg
            show={mailMsgView}
            alertHeader={t("preview_email")}
            alertMessage={emailMsg}
            handleClose={() => {
              setMailMsgView(false);
            }}
            language={data.language}
          ></ViewMailMsg>
        ) : null}

        {showPriestModal ? (
          <UpdatePriestPopUp
            showRegModal={showPriestModal}
            onHide={() => setShowPriestModal(false)}
            closeButton={true}
            data={priestData}
            setData={setPriestData}
            isEditAdmin={false}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            setEdiUserIdClicked={setEdiUserIdClicked}
            setShowREgModal={setShowPriestModal}
            getAllPriests={getAllPriests}
            userData={userData}
            oldValues={oldPriestValues}
            setOldValues={setOldPriestValues}
            isTempUpload={isTempPriestUpload}
            setIsTempUpload={setIsTempPriestUpload}
            redirect={false}
            onSuccess={handlePriestSuccess}
          />
        ) : null}
      </div>
    </RegistrationPasswordAuth>
  );
};

export default CreateOuterRetreat;
